import createAsyncActionType from '../utilities/createAsyncActionType';

export const GET_COUNTRIES = createAsyncActionType('GET_COUNTRIES');


// WEBPACK FOOTER //
// ./src/types/countryTypes.js